import { size } from 'lodash';
import { validateSync, ValidatorOptions } from 'class-validator';

export function validateSyncOrThrow(obj: object, validatorOptions?: ValidatorOptions) {
  const errors = validateSync(obj, validatorOptions);

  if (size(errors)) {
    throw errors;
  }
}

export default { validateSyncOrThrow };
